import React from 'react';
import {IonButton, IonButtons, IonTitle, IonToolbar} from '@ionic/react';
import {useHistory} from 'react-router-dom';
import classnames from 'classnames';

import Icon from 'shared/components/icon';
import NotificationAlert from 'src/components/notification-alert';

import styles from './mobile-title-navbar.module.scss';

interface Props {
  children: React.ReactNode;
  showBackButton?: boolean;
  overrideOnBack?: () => void;
  color?: 'blue' | 'white';
  rightButton?: {
    onClick: () => void;
    icon?: string;
    showAlert?: boolean;
    text?: string;
  };
}

const MobileTitleNavbar = ({
  children,
  showBackButton = true,
  overrideOnBack,
  color = 'white',
  rightButton,
}: Props): React.ReactElement => {
  const {goBack} = useHistory();

  return (
    <IonToolbar
      className={classnames(styles.toolbar, {
        [styles.blue]: color === 'blue',
        [styles.empty]: !children,
      })}
    >
      {showBackButton && (
        <IonButtons slot="start">
          <IonButton className={styles.button} onClick={overrideOnBack || goBack}>
            <Icon iconType="arrow-left" />
          </IonButton>
        </IonButtons>
      )}
      <IonTitle className={styles.title}>{children}</IonTitle>
      {rightButton && (
        <IonButtons slot="end">
          <IonButton className={styles.button} onClick={rightButton.onClick}>
            <NotificationAlert color={color} show={rightButton.showAlert}>
              {rightButton.icon && (
                <Icon
                  iconType={rightButton.icon}
                  className={classnames({[styles.white]: color === 'blue'})}
                />
              )}
            </NotificationAlert>
            <span className={styles.portfolioLink}>{rightButton.text}</span>
          </IonButton>
        </IonButtons>
      )}
    </IonToolbar>
  );
};

export default MobileTitleNavbar;
